import { makeAuthRequest } from '@/config/authApi.config';
import { PaginationParams } from '@/utils/common';

const path = '/notification';

type GetNotificationsParams = PaginationParams & {
  search?: string;
  userId?: number;
};

export const getNotifications = async (params: GetNotificationsParams) => {
  const res = await makeAuthRequest({
    method: 'GET',
    path,
    params,
    isShowError: false,
  });

  return res.result;
};

export const countNewNotifications = async () => {
  const res = await makeAuthRequest({
    method: 'GET',
    path: `${path}/count-new`,
    isShowError: false
  });

  return res.result;
};


// mask as read
// Mark notification as read
export const markAsRead = async (id: number) => {
  // Send PATCH request to mark notification as read
  const res = await makeAuthRequest({
    method: 'PATCH',
    path: `${path}/${id}/readed`,
    isShowError: false,
  });

  return res.result;
};